<template>
  <div id="menutracker"></div>
</template>

<script>
import endpoints from '../endpoints'
import axios from 'axios'

export default {
  name: 'MenuTracker',

  data () {
    return {
      sessionId: null
    }
  },

  watch: {
    $route () {
      this.update()
    }
  },

  created () {
    this.getSessionIdAndUpdate()

    document.addEventListener('visibilitychange', () => {
      this.onVisibilitychange()
    })
  },

  methods: {
    getSessionIdAndUpdate () {
      axios.get(endpoints.getSessionId)
        .then(response => {
          this.sessionId = response.data.sessionId
          this.update()
        })
    },

    update () {
      if (['Shop', 'Warenkorb', 'Generator'].includes(this.$router.history.current.name)) {
        // user joined a shop
        window.navigator.sendBeacon(endpoints.joinHost, JSON.stringify({
          host: this.$route.params.hostUrl,
          session: this.sessionId
        }))
      } else {
        // user has left a shop
        window.navigator.sendBeacon(endpoints.leaveHosts, JSON.stringify({
          session: this.sessionId
        }))
      }
    },

    onVisibilitychange () {
      if (document.visibilityState === 'hidden') {
        window.navigator.sendBeacon(endpoints.leaveHosts, JSON.stringify({
          session: this.sessionId
        }))
      } else {
        this.update()
      }
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/MenuTracker.vue